import React from "react";
import { Collapse } from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import IconSelect from "components/icons/IconSelect";

import "styles/FieldList.scss";
import {
  makeAttributeUserSelector,
  makeInputSelector,
} from "reducers/selectors";
import { ACTION_TYPE } from "reducers/actionType";
const Panel = Collapse.Panel;

class FieldList extends React.Component {
  toggleFosKey = (key) => {
    this.props.dispatch({
      type: ACTION_TYPE.STUDY.TOGGLE,
      data: key,
    });
  };

  // TODO: DO
  genCheckbox = (key) => {
    const { userStudys } = this.props;
    return (
      <span
        onClick={(event) => {
          event.stopPropagation();
          this.toggleFosKey(key);
        }}
      >
        <IconSelect selected={userStudys.includes(key)} />
      </span>
    );
  };

  // TODO: FIN
  genHeader = (key) => {
    const { userStudys } = this.props;
    const { fields_of_study } = this.props.input;
    return (
      <span
        className={
          "field-list-title " + (userStudys.includes(key) ? "selected" : "")
        }
      >
        <span
          onClick={(event) => {
            // event.stopPropagation();
            // toggleSelectFos(key);
          }}
        >
          {fields_of_study[key].description}
        </span>
      </span>
    );
  };

  getCareers = (key) => {
    const { CAREER } = this.props.input.attributes;
    const careerList = Object.keys(CAREER)
      .filter((career_id) => CAREER[career_id].fos_code.includes(key))
      .map((career_id) => CAREER[career_id].name);
    return careerList.join(", ");
  };

  render() {
    const { interests, skills, careers, input, courseAreas } = this.props;
    const { INTEREST, CAREER, SKILL } = input.attributes;
    const { fields_of_study, courses } = this.props.input;

    const annotatedFos = { ...fields_of_study };
    Object.keys(annotatedFos).forEach((key) => {
      annotatedFos[key].list = [];
    });

    interests.forEach((int) => {
      const currInt = INTEREST[int];
      const { fos_code } = currInt;
      fos_code.forEach((fos) => {
        annotatedFos[fos].list.push(currInt);
      });
    });

    skills.forEach((ski) => {
      const currSki = SKILL[ski];
      const { fos_code } = currSki;
      fos_code.forEach((fos) => {
        annotatedFos[fos].list.push(currSki);
      });
    });

    careers.forEach((car) => {
      const currCar = CAREER[car];
      const { fos_code } = currCar;
      fos_code.forEach((fos) => {
        annotatedFos[fos].list.push(currCar);
      });
    });

    courseAreas.forEach((ca) => {
      const course = courses[ca];
      const { primary_fos } = course;
      annotatedFos[primary_fos].list.push(course);
    });

    const contributors = Object.values(annotatedFos)
      .filter((af) => af.list.length)
      .sort((a, b) => (a.list.length < b.list.length ? 1 : -1));
    return (
      <div className="field-list">
        <Collapse bordered={false} expandIconPosition="right">
          {contributors
            .map((con) => con.fos_code)
            .map((key) => (
              <Panel
                className="field-list-panel"
                header={this.genHeader(key)}
                key={key}
                extra={this.genCheckbox(key)}
              >
                <h2 className="field-list-subtitle">Career opportunities</h2>
                <p className="field-list-body">{this.getCareers(key)}</p>
                <h2 className="field-list-subtitle">
                  Related tertiary courses
                </h2>
                <p className="field-list-body">
                  {fields_of_study[key].related_courses}
                </p>
              </Panel>
            ))}
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return createStructuredSelector({
    input: makeInputSelector,
    interests: makeAttributeUserSelector(ACTION_TYPE.INTEREST.ACCESS),
    skills: makeAttributeUserSelector(ACTION_TYPE.SKILL.ACCESS),
    careers: makeAttributeUserSelector(ACTION_TYPE.CAREER.ACCESS),
    courseAreas: makeAttributeUserSelector(ACTION_TYPE.COURSE.ACCESS),
    userStudys: makeAttributeUserSelector(ACTION_TYPE.STUDY.ACCESS),
  });
};
export default connect(mapStateToProps)(FieldList);
